import { Button, Checkbox } from '@mui/material';
import React, { useState } from 'react';
import { days } from '../../types/api/Days';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { getDateMonthNextSunday, getDateMonthPreviousMonday, getWeekNumber, getYearOfDate } from '../../tools/utils';
import Employee from '../../types/api/Employee';


interface WeeklyEmployeeAvailabilitiesProps {
    compact: boolean,
    readOnly: boolean,
    employee: Employee,
}
export function WeeklyEmployeeAvailabilities(EmployeeAvailabilitiesProps: WeeklyEmployeeAvailabilitiesProps) {
    const tableClassName = EmployeeAvailabilitiesProps.compact ? 'w-full' : '';
    const [selectedDate, setSelectedDate] = useState(new Date());

    if(EmployeeAvailabilitiesProps.employee.WeeklyAvailabilities.findIndex((item)=>{
        return item.EmployeeId === EmployeeAvailabilitiesProps.employee.id &&
            item.year === selectedDate.getFullYear() &&
            item.weekNumber === getWeekNumber(selectedDate)
    }) === -1){
        // If the current week does not have schedules, we create one with default values
        EmployeeAvailabilitiesProps.employee.WeeklyAvailabilities.push({
            EmployeeId: EmployeeAvailabilitiesProps.employee.id,
            year: selectedDate.getFullYear(),
            weekNumber: getWeekNumber(selectedDate),
            MondayNoon: false,
            MondayEvening: false,
            TuesdayNoon: false,
            TuesdayEvening: false,
            WednesdayNoon: false,
            WednesdayEvening: false,
            ThursdayNoon: false,
            ThursdayEvening: false,
            FridayNoon: false,
            FridayEvening: false,
            SaturdayNoon: false,
            SaturdayEvening: false,
            SundayNoon: false,
            SundayEvening: false,
        })
    }

    const [employeeWeeklyAvailabilities, setCurrentEmployeeWeeklyAvailabilities] = useState(EmployeeAvailabilitiesProps.employee.WeeklyAvailabilities);
    const [currentWeekIndex, setCurrentWeekIndex] = useState(employeeWeeklyAvailabilities.findIndex((item)=>{
        return item.EmployeeId === EmployeeAvailabilitiesProps.employee.id &&
            item.year === selectedDate.getFullYear() &&
            item.weekNumber === getWeekNumber(selectedDate)
    }));

    const updateCurrentWeeklyAvailability = (newDate: Date) => {
        const idx = employeeWeeklyAvailabilities.findIndex((item)=>{
            return item.EmployeeId === EmployeeAvailabilitiesProps.employee.id &&
                item.year === newDate.getFullYear() &&
                item.weekNumber === getWeekNumber(newDate)
        })
        if(idx !== -1){
            setCurrentWeekIndex(idx)
        }else{
            const newItems = employeeWeeklyAvailabilities
            newItems.push({
                EmployeeId: EmployeeAvailabilitiesProps.employee.id,
                year: newDate.getFullYear(),
                weekNumber: getWeekNumber(newDate),
                MondayNoon: false,
                MondayEvening: false,
                TuesdayNoon: false,
                TuesdayEvening: false,
                WednesdayNoon: false,
                WednesdayEvening: false,
                ThursdayNoon: false,
                ThursdayEvening: false,
                FridayNoon: false,
                FridayEvening: false,
                SaturdayNoon: false,
                SaturdayEvening: false,
                SundayNoon: false,
                SundayEvening: false,
            })
            setCurrentWeekIndex(employeeWeeklyAvailabilities.length-1)
        }
    }

    const previousWeek = () => {
        const newDate = new Date(selectedDate.getTime())
        newDate.setDate(newDate.getDate()-7)
        updateCurrentWeeklyAvailability(newDate)
        setSelectedDate(newDate)
    }

    const nextWeek = () => {
        const newDate = new Date(selectedDate.getTime())
        newDate.setDate(newDate.getDate()+7)
        updateCurrentWeeklyAvailability(newDate)
        setSelectedDate(newDate)
    }

    return (
        <div>
            <div className='flex justify-center'>
                <Button onClick={previousWeek} endIcon={<ArrowBackIosIcon/>} size='large'/>
                <h2 className='text-lg font-bold'>Semaine n°{getWeekNumber(selectedDate)} du {getDateMonthPreviousMonday(selectedDate)} au {getDateMonthNextSunday(selectedDate)}  {getYearOfDate(selectedDate)}</h2>
                <Button onClick={nextWeek} endIcon={<ArrowForwardIosIcon/>} size='large'/>
            </div>
            <table className={tableClassName}>
                <tbody>
                    <tr>
                        <th></th>
                        <th className='p-1'>{days.Monday}</th>
                        <th className='p-1'>{days.Tuesday}</th>
                        <th className='p-1'>{days.Wednesday}</th>
                        <th className='p-1'>{days.Thursday}</th>
                        <th className='p-1'>{days.Friday}</th>
                        <th className='p-1'>{days.Saturday}</th>
                        <th className='p-1'>{days.Sunday}</th>
                    </tr>

                    <tr className='text-center'>
                        <td>MIDI</td>
                        <td>
                        <Checkbox 
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].MondayNoon}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].MondayNoon = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].TuesdayNoon}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].TuesdayNoon = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].WednesdayNoon}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].WednesdayNoon = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].ThursdayNoon}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].ThursdayNoon = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].FridayNoon}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].FridayNoon = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].SaturdayNoon}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].SaturdayNoon = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].SundayNoon}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].SundayNoon = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        
                    </tr>
                    <tr className='text-center'>
                        <td>SOIR</td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].MondayEvening}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].MondayEvening = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].TuesdayEvening}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].TuesdayEvening = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].WednesdayEvening}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].WednesdayEvening = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].ThursdayEvening}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].ThursdayEvening = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].FridayEvening}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].FridayEvening = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].SaturdayEvening}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].SaturdayEvening = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                        <td>
                        <Checkbox
                            color="success"
                            disabled={EmployeeAvailabilitiesProps.readOnly}
                            checked={employeeWeeklyAvailabilities[currentWeekIndex].SundayEvening}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                const newArray = [...employeeWeeklyAvailabilities]
                                newArray[currentWeekIndex].SundayEvening = event.target.checked
                                setCurrentEmployeeWeeklyAvailabilities(newArray)
                            }}
                        />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default WeeklyEmployeeAvailabilities;